<template>
    <div :class="{'container-dark': theme_dark}">
      <div class="nav-top">
        <div class="nav-left" @click="back()">
          <img src="../../assets/img/返回箭头.png" class="nav-img" />
          <span class="nav-lable"></span>
        </div>
        <div class="nav-middle">赚积分规则</div>
        <div class="nav-right">
          <span class="nav-lable"></span>
          <img src="../../assets/img/更换.png" class="nav-img none" />
        </div>
      </div>
  
      <ul>
        <li class="item">
          <p class="question"><span class="tag"></span>规则说明</p>
          <div class="answer">参与赚积分任务活动前，请您详细阅读并知悉本次活动规则及相关条款。凡参与本次活动，即视为用户已阅读、理解、并同意活动规则及特别提示的全部内容，最终解释权归小火柴所有。</div>
        </li>
  
        <li class="item">
          <p class="question"><span class="tag"></span>活动简介</p>
          <div class="answer">1、用户进入小火柴客户端后，登录小火柴，完成签到、聊天、送礼物、分享等任务，即可获得平台一定数额的积分奖励。</div>
          <div class="answer">2、不同的任务奖励不同，不同的用户也会获得不同的任务配置，且奖励会根据参与情况实时调整，具体任务完成次数和具体奖励数额以活动页面展示为准。</div>
          <div class="answer">3、用户可通过点击小火柴首页右下角“我的”→“我的钱包”→“积分奖励”入口进入活动页面。</div>
          <div class="answer">4、注意：部分功能可能处于试点阶段，平台将根据试点效果及运营能力等多方面因素决定试点的范围及内容，具体以活动页面展示为准。部分用户可能在试点期间无法查看相关功能，敬请谅解。</div>
        </li>

        <li class="item">
          <p class="question"><span class="tag"></span>私信收入</p>
          <div class="answer">
            <p class="answer-item">1、用户可以自行设置聊天收费，其他用户与自己聊天时需要支付的相应的金币。当其他用户想要与自己聊天便需要支付一定数额的金币才能开始聊天，每人每天仅可设置一次！</p>
            <p class="answer-item mg-top">2、用户可以在赚积分页面进行聊天收费的设置，默认为免费。</p>
            <p class="answer-item mg-top">3、当其他用户与自己产生聊天时所支付的金币会自动计入到“我的钱包”，详情可查看挣钱明细。</p>
            <p class="answer-item mg-top">4、打招呼阶段是不计算收益的，包括对招呼的回复，后续的聊天回复会根据你设定的收费标准进行收益。</p>
            <p class="answer-item mg-top">5、如果设置了聊天收费，回复用户即可得积分，回复越及时，所得积分越高，12小时内回复都有积分。</p>
            <p class="answer-item mg-top">6、成为好友，或者设置了免费等情况是没有积分收益的。</p>
          </div>
        </li>
  
        <li class="item">
          <p class="question"><span class="tag"></span>登录奖励规则</p>
          <div class="answer">
            <p class="answer-item">1、用户每日登录小火柴客户端进行签到，即可获得平台一定的积分奖励。</p>
            <p class="answer-item mg-top">2、连续签到：自首次完成签到开始累计，连续7天签到为一个周期。连续签到所得奖励在周期内稍有变化，非均等分布。连续签到的第7天可额外领取连签奖。</p>
            <p class="answer-item mg-top">3、断签：在签到周期内，未完成签到规则视为发生断签。断签后，当前周期内的签到奖励将会变成最低值，连签奖将根据实际签到情况重新计算。</p>
            <p class="answer-item mg-top">4、每日同一注册用户仅可参与一次。</p>
          </div>
        </li>

        <li class="item">
          <p class="question"><span class="tag"></span>打招呼奖励规则</p>
          <div class="answer">
            <p class="answer-item">用户在登录小火柴后，向其他用户发送打招呼的消息即可获得一定数额的奖励积分。</p>
          </div>
        </li>

        <li class="item">
          <p class="question"><span class="tag"></span>回复奖励规则</p>
          <div class="answer">
            <p class="answer-item">用户在消息页面对其他用户的消息进行答复或回应即可获得一定数额的奖励积分。</p>
          </div>
        </li>

        <li class="item">
          <p class="question"><span class="tag"></span>在线奖励规则</p>
          <div class="answer">
            <p class="answer-item">1、用户需要在小火柴保持在线状态，并能够与其他用户进行匹配聊天即可领取在线奖励。</p>
            <p class="answer-item mg-top">2、在连续登录的3分钟内，能够与其他用户发送消息则视为在线状态。若中途有短暂的退出小火柴，但是再次上线后能够继续与其他用户进行聊天，那么退出的时间也依然会算作在线时间。</p>
            <p class="answer-item mg-top">3、小火柴鼓励持续在线与其他用户聊天，在线时间越长奖励就会越高~每天可高达8000积分呢~</p>
          </div>
        </li>

        <li class="item">
            <p class="question"><span class="tag"></span>礼物奖励规则</p>
            <div class="answer">
            <p class="answer-item">1、用户每日首次收到的聊天对象送来的礼物，即可获得平台一定的积分奖励。</p>
            <p class="answer-item mg-top">2、用户在聊天过程中，收到聊天对象送来的礼物，即可获得 100到 10万不等的积分。</p>
            <p class="answer-item mg-top">3、不同的礼物对应不同的积分。礼物的积分规则如下：</p>
            <div class="gift-block ub ub-ver">
              <div class="ub ub-pc ub-ac1 title">
                <div>礼物</div>
                <div>名称</div>
                <div>积分</div>
              </div>
              <li v-for="(item, index) in ary_gift" :key="index">
                <div class="line"></div>
                <div class="ub ub-pc ub-ac1 gift_item">
                  <img :src="item.url" />
                  <div>{{item.name}}</div>
                  <div>{{item.score}}&nbsp;</div>
                </div>
              </li>
            </div>
          </div>
        </li>

        <li class="item">
            <p class="question"><span class="tag"></span>分享奖励规则</p>
            <div class="answer">
            <p class="answer-item">1、用户将小火柴系统生成的链接分享给微信好友、朋友圈、群聊，即可完成分享。</p>
            <p class="answer-item mg-top">2、好友进入小火柴后，用户即可获得平台一定的积分奖励。</p>
          </div>
        </li>
  
    </ul>
    </div>
  </template>
  
  <script>
  import * as tool from "../../api/common";
    export default {
      data() {
        return {
            ary_gift: [],
          theme_dark: false
        };
      },
      mounted() {
        //切换深色模式
        this.theme_dark = tool.is_theme_dark(this);
        this.init_page();
      },
      methods: {
        back() {
          this.$router.go(-1); //返回上一层
        },
        
        init_page() {
            var const_data = this.$store.state.const_data;
            this.ary_gift = const_data.gift_1.concat(const_data.gift_2);
        }
      }
    };
  </script>
  
  <style lang="scss" scoped>
    .item {
      padding: 0.5rem;
      .question {
        margin: 0;
        color: #000;
        font-weight: 600;
        .tag {
          display: inline-block;
          width: 0.2rem;
          height: 0.9rem;
          background-color: #e92162;
          margin-right: 0.2rem;
        }
      }
      .answer {
          font-size: 0.8rem;
          color: #565656;
          line-height: 1.6rem;
          margin-top: 0.5rem;
          .answer-item {
            margin: 0;
            padding: 0;
          }
          .mg-top {
              margin-top: .5rem;
          }
          .gift-block {
            border: 1px solid #dcdcdc;
            .title {
              height: 2rem;
            }
            .gift_item {
              img {
                  width: 3rem;
                  height: 3rem;
              }
            }
          }
          .line {
            border-top: 1px solid #dcdcdc;
         }
        }
    }
  
  .container-dark {
    min-height: 100vh;
    background-color: #2F2E33;
    .question {
      color: #FDFDFD;
    }
    .answer {
      color: #888;
    }
  }
  </style>